const _ = require('lodash');
const jQuery = require('jquery');

const Container = require('./../../../core/container');
const Mediator = require('./../../../core/mediator');

const Translator = require('./../../../core/translator');

const ContentManager = require('./../component/ContentManager');
const Dnd = require('./../../../services/dnd');
const DndZone = require('./../service/dndZone');
const ResizePlugin = require('./resize');

const contentEditToolbarTpl = require('./../template/content_edit_toolbar.hbs');

'use strict';

module.exports.clearPluginsToolbar = () => {
    let $current = jQuery('.bb-content.fixed');

    if ($current.length) {
        $current.removeClass('fixed');
        module.exports.onMouseLeave(ContentManager.getContentByNode($current));
    }

    return $current;
};

module.exports.onClick = (content, force) => {
    let forbiddenPlugins = content.getForbiddenPlugins();

    if (_.indexOf(forbiddenPlugins, 'fixe-plugins')) {
        return;
    }

    let $current = module.exports.clearPluginsToolbar();

    if (Container.get('ui_status') === 'disabled') {
        return true;
    }

    if (content.$) {
        if (!content.$.is($current) || force) {
            content.$.addClass('fixed');
            module.exports.onMouseenter(content);
        }
    }
};

module.exports.onMouseenter = (content) => {
    let forbiddenPlugins = content.getForbiddenPlugins();
    let toolbar = content.$.children('.cloud-edit-content');
    let $dndBtn;
    let isGlobalContent = content.$.parents('footer').length || content.$.parents('nav').length;

    if (isGlobalContent) {
        if (!Container.get('isAllowedTo')('GLOBAL_CONTENT_FEATURE')) {
            return true;
        }
    } else {
        if (!(Container.get('isAllowedTo')('EDIT_CONTENT') || Container.get('isAllowedTo')('CREATE_CONTENT'))) {
            return true;
        }
    }

    if (Container.get('ui_status') === 'disabled') {
        return true;
    }

    content.addClass('cloud-editable').removeClass('cloud-highlight-content');

    jQuery('.missing-config-wrapper').parent().addClass('not-set-block');

    if (toolbar.length === 0 && !Container.get('$siteWrapper').hasClass('rte')) {
        let showResize = -1 === _.indexOf(forbiddenPlugins, 'resize') &&
                                content.$.children('.missing-config-wrapper').length === 0 &&
                                content.getProperties('resizable') === true &&
                                !content.getProperties('is_image');

        let showParameterLabel = 1 === content.$.parent('.has-sub-elements').length;
        let showRemove = isGlobalContent ? !forbiddenPlugins.includes('remove') : Container.get('isAllowedTo')('DELETE_CONTENT') && !forbiddenPlugins.includes('remove');
        let showParameter = isGlobalContent ? !forbiddenPlugins.includes('parameter') && Object.keys(content.definition.parameters).length > 0 : Container.get('isAllowedTo')('EDIT_CONTENT') && !forbiddenPlugins.includes('parameter') && Object.keys(content.definition.parameters).length > 0;
        let showDnd = isGlobalContent ? !forbiddenPlugins.includes('dnd') : Container.get('isAllowedTo')('CREATE_CONTENT') && !forbiddenPlugins.includes('dnd');

        toolbar = jQuery(contentEditToolbarTpl({
            'label': content.definition.label,
            'showRemove': showRemove,
            'showParameter': showParameter,
            'showDnd': showDnd,
            'showResize': showResize,
            'showParameterLabel': showParameterLabel,
        }));
        let $moreOptions = toolbar.find('.more-options:first');

        Mediator.publish('on:plugin-content:build', {
            'content': content,
            '$toolbar': toolbar,
        });

        let $buttons = $moreOptions.find('button');
        let $btnMore = toolbar.find('.btn-more');
        if ($buttons.length === 0) {
            $btnMore.addClass('d-none');
        } else if ($buttons.length === 1) {
            $btnMore.addClass('d-none');
            $moreOptions.removeClass('more-options');
        }

        toolbar.find('.btn-remove').publish('content:plugin:remove', content);
        toolbar.find('.btn-parameter').publish('content:plugin:parameter', content);
        toolbar.find('.cloud-resize').publish('content:plugin:resize', content, 'mousedown');

        $dndBtn = toolbar.find('.btn-cloud-grip');
        if ($dndBtn.length) {
            content.$.data('dnd-height', content.$.outerHeight());

            Dnd.draggable(content.$, undefined, {
                'handle': $dndBtn,
                'iframeFix': true,
                'containment': [0, 0, (jQuery(window).width() + 100), jQuery(document).height()],
                'revert': function(event) {
                    let $current = jQuery(this);
                    let data = $current.data('ui-draggable');

                    if ($current.hasClass('send-request')) {
                        return false;
                    }

                    if (data) {
                        data.originalPosition = {
                            top: 0,
                            left: 0,
                        };
                    }

                    setTimeout(function() {
                        $current.removeClass('d-none');
                        DndZone.apply();
                    }, 600);

                    return !event;
                },
                'cursorAt': '20',
                'helper': function() {
                    let $element = jQuery(this);
                    let $clone = $element.clone();

                    $element.addClass('d-none');

                    $clone.css('width', '200px');
                    $clone.css('margin-left', '-100px');
                    $clone.css('opacity', '0.2');
                    $clone.addClass('ghost-dnd');

                    return $clone;
                },
            });
        }

        let $parameterLabel = toolbar.find('.parameters-label');
        if ($parameterLabel.length === 1) {
            $parameterLabel.text(
                `${Translator.translate('subelement_parameter_label_prefix')} ${Translator.translate(content.definition.properties.name)}`,
            );
        }

        content.$.append(toolbar);

        Mediator.publish('after:set:plugins:content', {
            'content': content,
            '$toolbar': toolbar,
        });
    } else {
        toolbar.removeClass('d-none');
    }

    if (toolbar.find('.cloud-resize').length === 1) {
        setTimeout(function() {
            ResizePlugin.calculButtonPosition(toolbar.find('.cloud-resize'), content);
        }, 100);
    }

    let $colMd = content.$.parents('.colcontentset').parent();

    $dndBtn = toolbar.find('.btn-cloud-grip');
    $dndBtn[$colMd.hasClass('col-md-2') ? 'addClass' : 'removeClass']('small');

    Mediator.publish('after:set:plugins:content', {
        'content': content,
        '$toolbar': toolbar,
    });
};

module.exports.onMouseLeave = (content) => {
    content.removeClass('cloud-editable');
    content.$.find('.cloud-edit-content').addClass('d-none');
};
